import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification, Card, Result, Radio, Space, Grid } from 'antd';
import { Button, Input } from 'antd';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeSelect,
	XThemeRadio,
	XThemeModal,
	XEditButtonIcon,
} from '../../styles/GlobalThemeStyle';

import moment from 'moment';
import CaseSearch from '../../components/CaseSearch/CaseSearch';
// actions

import { getHospitalDropdownApi } from '../../actions/getHospitalDropdownAction';
import {
	checkModulePermissions,
	truncateString,
	urlPagination,
} from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import {
	filterByLabel,
	handleInputChange,
	handleSelectChange,
} from '../../utils/formFunctions';

import { getRegionsReset, getRegionsApi } from '../../actions/getRegionsAction';
import {
	getRegionByIdApi,
	getRegionByIdReset,
} from '../../actions/getRegionByIdAction';
import { editRegionApi, editRegionReset } from '../../actions/editRegionAction';
import {
	deleteRegionApi,
	deleteRegionReset,
} from '../../actions/deleteRegionAction';
import { addRegionApi, addRegionReset } from '../../actions/addRegionAction';

import {
	getOrganizationsApi,
	getOrganizationsReset,
} from '../../actions/getOrganizationsAction';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';

const Regions = (props) => {
	const {
		getHospitalDropdownState,
		getRegionsState,
		getRegionByIdState,
		editRegionState,
		deleteRegionState,
		addRegionState,
		getHospitalDropdown,
		getRegions,
		getRegionById,
		editRegion,
		deleteRegion,
		addRegion,
		editRegionReset,
		addRegionReset,
		getOrganizations,
		getOrganizationsState,
	} = props;

	const navigate = useNavigate();
	const defaultFilters = {
		search: '',
		page: 1,
		sort: 'updatedAt',
		sortDirection: 'descend',
		created_on: 'all',
		hospitals: [],
		limit: 10,
	};
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const [modalOpen, setModalOpen] = useState([false, '']);
	const [editRegionModal, setEditRegionModal] = useState(false);
	const [displayOrgInput, setDisplayOrgInput] = useState(false);
	let modulePermissions = checkModulePermissions('region-management');

	const [form] = XThemeForm.useForm();
	const [form2] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});
	const [submitLoading, setSubmitLoading] = useState(false);
	const [loading, setLoading] = useState(false);

	const [open, setOpen] = useState(false);
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const columns = [
		{
			title: 'Name',
			width: 200,
			dataIndex: 'name',
			fixed: 'left',
			render: (name) => (
				<div>
					<div>{name}</div>
				</div>
			),
		},
		{
			title: 'Hospitals',
			dataIndex: 'hospitals',
			render: (hospitals) => (
				<div>
					<div>{hospitals}</div>
				</div>
			),
		},
		{
			title: 'Organization',
			dataIndex: 'organization',
			render: (organization) => (
				<div>
					<div>{organization}</div>
				</div>
			),
		},
		{
			title: 'Created At',
			dataIndex: 'createdAt',
			render: (createdAt) => (
				<div>
					<div>{createdAt}</div>
				</div>
			),
		},
		{
			title: 'Action',
			width: 150,
			dataIndex: 'action',
			align: 'center',
		},
	];

	const showDeleteConfirm = (_id, name) => {
		XThemeModal.confirm({
			title: 'Delete Region?',
			content: (
				<p className="modalPara1">
					Are you sure you want to delete {name}?
				</p>
			),
			icon: (
				<span className="modalTitleIcon">
					<img src="/images/delete-modal-icon.svg" alt="delete" />
				</span>
			),
			okText: 'Yes, Confirm',
			okType: 'danger',

			cancelText: 'No, Cancel',
			// className: 'confirmModal',
			okButtonProps: {
				className: 'xThemeButtonSubmit',
			},
			cancelButtonProps: {
				className: 'xThemeCancelSubmit',
			},
			onOk() {
				setLoading(true);
				deleteRegion({ id: _id });
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};

	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;

	const handleEdit = (item) => {
		if (isMobile) {
			navigate(`/regions/edit/${item._id}`);
		} else {
			setEditRegionModal(true);
			setFormData({
				_id: item._id,
			});
			setModalOpen([true, `Edit Region`]);
			getRegionById({
				id: item._id,
			});
			getOrganizations();
		}
	};

	// use effects
	useEffect(() => {
		if (getRegionsState.apiState === 'loading') {
			setLoading(true);
		}
		if (getRegionsState.apiState === 'success') {
			if (getRegionsState.data.regions.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getRegionsState.data.total_count);
				getRegionsState.data.regions.map((item, index) => {
					updatedSearchOptions.push({ value: item.name });
					updatedData.push({
						key: item._id,
						_id: item._id,
						name: item.name,
						hospitals: item.hospitals
							? truncateString(item.hospitals, 80)
							: '-',
						organization: item.organization,
						createdAt: (
							<div className="showDate">
								{moment(item.createdAt).format('DD-MM-YYYY')}
							</div>
						),
						action: (
							<div className="text-center">
								<Row>
									<Col xs={{ span: 6, offset: 6 }}>
										{modulePermissions.sub_modules.includes(
											'update-regions',
										) && (
											<XEditButtonIcon
												onClick={() => {
													handleEdit(item);
												}}
												type="text"
											>
												<img
													src="./images/pencil.svg"
													alt=""
												/>
											</XEditButtonIcon>
										)}
									</Col>
									<Col xs={{ span: 9, offset: 3 }}>
										{modulePermissions.sub_modules.includes(
											'delete-regions',
										) && (
											<XEditButtonIcon
												onClick={() =>
													showDeleteConfirm(
														item._id,
														item.name,
													)
												}
												type="text"
											>
												<img
													src="./images/delete-icon-card.svg"
													alt=""
												/>
											</XEditButtonIcon>
										)}
									</Col>
								</Row>
							</div>
						),
					});
				});
				setTableData(updatedData);
				setLoading(false);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getRegionsState]);

	useEffect(() => {
		if (getRegionByIdState.apiState === 'success') {
			setFormData({
				id: getRegionByIdState.data._id,
				name: getRegionByIdState.data.name,
				hospitals: getRegionByIdState.data.hospitals.map(
					(ele) => ele._id,
				),
				organization: getRegionByIdState.data.organization.id,
			});
			form.setFieldsValue({
				id: getRegionByIdState.data._id,
				name: getRegionByIdState.data.name,
				hospitals: getRegionByIdState.data.hospitals.map(
					(ele) => ele._id,
				),
				organization: getRegionByIdState.data.organization.id,
			});
		}
	}, [getRegionByIdState]);

	useEffect(() => {
		if (editRegionState.apiState === 'success') {
			setFormData({});
			editRegionReset();
			getRegions();

			notification.success({
				message: editRegionState.message,
			});
			form.resetFields();
			setSubmitLoading(false);
			setModalOpen([false, '']);
		} else if (editRegionState.apiState === 'error') {
			setSubmitLoading(false);
			notification.error({
				message: editRegionState.message,
			});
			editRegionReset();
		}
	}, [editRegionState]);

	useEffect(() => {
		if (addRegionState.apiState === 'success') {
			setFormData({});
			addRegionReset();
			getRegions();
			notification.success({
				message: addRegionState.message,
			});
			form.resetFields();
			setSubmitLoading(false);
			setModalOpen([false, '']);
		} else if (addRegionState.apiState === 'error') {
			setSubmitLoading(false);
			notification.error({
				message: 'Error in adding Region',
			});
			addRegionReset();
		}
	}, [addRegionState]);

	useEffect(() => {
		if (deleteRegionState.apiState === 'success') {
			console.log('delllllllll');
			deleteRegionReset();
			getRegions();
			getOrganizations();
		}
	}, [deleteRegionState]);

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		// Make API call with updated filters and pagination
		setFilters({ ...updatedFilters });
		getRegions({ ...updatedFilters });
	}, [window.location.search]);

	useEffect(() => {
		localStorage.getItem('role') === 'organization-admin'
			? setDisplayOrgInput(true)
			: setDisplayOrgInput(false);
	}, []);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	const addRegionSubmit = () => {
		addRegion({
			...formData,
		});
	};

	const updateRegionSubmit = () => {
		editRegion({
			...formData,
		});
	};
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Regions" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="regions" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{modulePermissions.sub_modules.includes('list-regions') ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Region Management
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage regions
								</XTheme2Para1>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								{modulePermissions.sub_modules.includes(
									'add-regions',
								) ? (
									<>
										{isMobile ? (
											<Link to="/regions/add">
												<XTheme2Button
													className="noBackground borderColor"
													shape="circle"
													size="large"
													// onClick={() => {
													// 	form.resetFields();
													// 	setModalOpen([
													// 		true,
													// 		'Add Region',
													// 	]);
													// 	getOrganizations();
													// 	setEditRegionModal(
													// 		false,
													// 	);
													// }}

													icon={<PlusOutlined />}
												/>
											</Link>
										) : (
											<XTheme2Button
												size="large"
												icon={<PlusOutlined />}
												onClick={() => {
													form.resetFields();
													setModalOpen([
														true,
														'Add Region',
													]);
													getOrganizations();
													setEditRegionModal(false);
												}}
											>
												Add Region
											</XTheme2Button>
										)}
									</>
								) : (
									<></>
								)}
							</Col>
						</Row>

						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<CaseSearch
									filters={[
										<XThemeForm.Item
											name="hospitals"
											colon={false}
											label="Hospitals"
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												allowClear
												className="noBorderRadius"
												mode="multiple"
												maxTagCount={(3, 'responsive')}
												showSearch={true}
												placeholder="Select Hospitals"
												defaultValue={
													filters.hospitals
														? filters.hospitals
														: []
												}
												onFocus={() => {
													getHospitalDropdown();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getHospitalDropdown({
															search,
														});
													} else if (
														search.length === 0
													) {
														getHospitalDropdown();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														hospitals: '',
													});
												}}
												filterOption={filterByLabel}
												options={
													getHospitalDropdownState.apiState ===
														'success' &&
													getHospitalDropdownState
														.data.hospitals
														?.length > 0 &&
													getHospitalDropdownState.data.hospitals.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onChange={(value, options) => {
													setFilters({
														...filters,
														hospitals: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="created_on"
											colon={false}
											label="Date Within"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="created_on"
												defaultValue={
													filters.created_on
														? filters.created_on
														: null
												}
											>
												<Row>
													{dateFilters.map(
														(item, index) => (
															<Col
																xs={12}
																md={12}
																lg={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
									]}
									onClose={onClose}
									open={open}
									applyFilters={applyFilters}
									form={form2}
									clearFilters={clearFilters}
								/>

								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col xs={16} sm={16} md={6} lg={4}>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Regions
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="d-none d-md-block"
									>
										<Space>
											<XTheme2InputText
												size="large"
												allowClear
												placeholder="Search by Region Name"
												defaultValue={
													filters.search
														? filters.search
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														urlPagination(
															filters,
															'search',
															'',
														);
														setFilters({
															...filters,
															search: '',
														});
													} else {
														setFilters({
															...filters,
															search: v.target
																.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.search
																? filters.search
																: '';
														if (searchValue) {
															urlPagination(
																filters,
																'search',
																searchValue,
															);
															setFilters({
																...filters,
																search: searchValue,
															});
														}
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														urlPagination(
															filters,
															'search',
															searchValue,
														);
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
									<Col
										xs={8}
										sm={8}
										md={6}
										lg={8}
										className="text-end"
									>
										<Space>
											<XTheme2Button
												className="noBackground borderColor"
												shape="circle"
												size="large"
												onClick={() => showDrawer()}
												icon={
													<img
														src="/images/theme-filter-icon.svg"
														alt="filter"
													/>
												}
											/>

											{/* {modulePermissions.sub_modules.includes(
												'add-regions',
											) ? (
												<XThemeFilterButton
													className="backgroundRevers"
													onClick={() => {
														form.resetFields();
														setModalOpen([
															true,
															'Add Region',
														]);
														getOrganizations();
														setEditRegionModal(
															false,
														);
													}}
													icon={<PlusCircleFilled />}
												>
													Region
												</XThemeFilterButton>
											) : (
												<></>
											)} */}
										</Space>
									</Col>
								</Row>
							</div>

							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								// state={getRegionsState.apiState}
								state={loading ? 'loading' : ''}
								page={'region'}
								handleEdit={handleEdit}
								showDeleteConfirm={showDeleteConfirm}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>

			<XThemeModal
				title={modalOpen[1]}
				centered
				open={modalOpen[0]}
				onCancel={() => {
					form.resetFields();
					setFormData({});
					setModalOpen([false, '']);
				}}
				footer={null}
				// okButtonProps={{
				// 	style: {
				// 		display: 'none',
				// 		backgroundColor: '#007299',
				// 		borderColor: '#007299',
				// 		color: '#fff',
				// 	},
				// }}
				// cancelButtonProps={{
				// 	style: {
				// 		display: 'none',
				// 		background: '#fff',
				// 		color: '#007299',
				// 		borderRadius: '20px',
				// 	},
				// }}
			>
				<XThemeForm
					form={form}
					name="roleForm"
					layout="vertical"
					autoComplete="off"
					onFinish={() => {
						setSubmitLoading(true);
						editRegionModal
							? updateRegionSubmit()
							: addRegionSubmit();
					}}
				>
					<Row gutter={(15, 15)} className="mt-4">
						<Col xs={24}>
							<XThemeForm.Item
								className="drawerlabel"
								name="name"
								label="Name"
								rules={[
									{
										required: true,
										message: 'Please enter Region name',
									},
								]}
							>
								<XThemeInputText
									prefix={
										<img
											src="/images/input-user-icon.svg"
											alt=""
										/>
									}
									className="largeInputForms"
									size="large"
									placeholder="Enter Region Name"
									name="name"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						{displayOrgInput ? (
							<></>
						) : (
							<Col xs={24}>
								<XThemeForm.Item
									className="drawerlabel"
									name="organization"
									label={'Organization'}
									rules={[
										{
											required: true,
											message: 'Please enter Region name',
										},
									]}
								>
									<XThemeSelect
										className="largeInputForms"
										size="large"
										placeholder="Select Organization"
										name="organization"
										showSearch={true}
										onSearch={(search) => {
											if (search.length >= 3) {
												getOrganizations({
													search,
												});
											} else if (search.length === 0) {
												getOrganizations();
											}
										}}
										filterOption={filterByLabel}
										options={
											getOrganizationsState.apiState ===
												'success' &&
											getOrganizationsState.data.list
												?.length > 0 &&
											getOrganizationsState.data.list.map(
												(itm) => {
													return {
														label: itm.name,
														value: itm._id,
													};
												},
											)
										}
										onSelect={(value, options) => {
											handleSelectChange(
												'organization',
												value,
												formData,
												setFormData,
											);
										}}
									/>
								</XThemeForm.Item>
							</Col>
						)}
					</Row>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="text-center text-sm-end">
							<Space>
								<Button
									className="xThemeCancelSubmit"
									size="large"
									onClick={() => {
										form.resetFields();
										setFormData({});
										setModalOpen([false, '']);
									}}
								>
									Cancel
								</Button>

								<Button
									className="xThemeButtonSubmit"
									loading={submitLoading}
									htmlType="submit"
									size="large"
									disabled={
										(editRegionModal &&
											!modulePermissions.sub_modules.includes(
												'update-regions',
											)) ||
										!modulePermissions.sub_modules.includes(
											'add-regions',
										)
									}
								>
									Submit
								</Button>
							</Space>
						</Col>
					</Row>
				</XThemeForm>
			</XThemeModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	getHospitalDropdownState: state.getHospitalDropdown,
	getRegionsState: state.getRegions,
	getRegionByIdState: state.getRegionById,
	editRegionState: state.editRegion,
	deleteRegionState: state.deleteRegion,
	addRegionState: state.addRegion,
	getOrganizationsState: state.getOrganizations,
});

const mapDispatchToProps = (dispatch) => ({
	getRegions: (params) => dispatch(getRegionsApi(params)),
	getRegionsReset: (params) => dispatch(getRegionsReset(params)),
	getRegionById: (params) => dispatch(getRegionByIdApi(params)),
	getRegionByIdReset: (params) => dispatch(getRegionByIdReset(params)),
	editRegion: (params) => dispatch(editRegionApi(params)),
	editRegionReset: (params) => dispatch(editRegionReset(params)),
	deleteRegion: (params) => dispatch(deleteRegionApi(params)),
	deleteRegionReset: (params) => dispatch(deleteRegionReset(params)),
	addRegion: (params) => dispatch(addRegionApi(params)),
	addRegionReset: (params) => dispatch(addRegionReset(params)),
	getHospitalDropdown: (params) => dispatch(getHospitalDropdownApi(params)),
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
	getOrganizationsReset: () => dispatch(getOrganizationsReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Regions);
